export const processSyncType = {
    INIT: "INIT",
    STARTED: "STARTED",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    INCOMPLETE: "INCOMPLETE"
};

export const subProcessSyncType = {
    STARTED: "STARTED",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/synchronizations/synchronizationTypes.js